import { useQuery } from '@apollo/client';
import { usePaginationAndFilter } from 'components/template/ListTemplate/hooks/usePaginationAndFilter';
import { GRAPHQL_BUSCAR_SAQUES } from 'gql/saque';
import { useEffect } from 'react';
import { IQuerySaques } from './index.d';

export const useQueryFilterSaques = () => {
    const props = usePaginationAndFilter({
        dataKeyName: null,
        keysQueryVariavel: ['status', 'dataInicial', 'dataFinal'],
    });

    const { loading } = useQuery<IQuerySaques>(GRAPHQL_BUSCAR_SAQUES, {
        context: props.context,
        variables: props.variables,
        fetchPolicy: 'network-only',
        onCompleted: ({ saques }) => props.onCompleted(saques),
        onError: props.onError,
    });

    useEffect(() => {
        props.setLoading(loading);
    }, [loading]);

    return { ...props, dataSelectHeader: [] };
};
